// A probe that has not reported in this long is treated as offline, not as a fresh
// reading. Devices push roughly once a minute. Shared by the Dashboard and Hydro
// Units so both call a unit offline at the same moment.
export const STALE_AFTER_SECONDS = 20 * 60;

/* A reading only counts if it is recent. Averaging a stale value is worse than
   showing fewer inputs: if the back room dropped off an hour ago, folding its last
   temperature into the inside average reports a number no sensor is measuring. */
export function isFresh(timestamp, maxAgeSeconds = STALE_AFTER_SECONDS) {
  if (!timestamp) return false;
  return Math.floor(Date.now() / 1000) - timestamp <= maxAgeSeconds;
}

/* A light controller's link state, from one /devices/relay-status unit row. The
   server decides online (DEVICE_STALE_AFTER_SECONDS, 3 min, on its own clock) and
   `since` (back online = when the alert monitor saw it return, the moment the
   WhatsApp "back" message names; offline = its last report). This only words it,
   so the Dashboard tiles and Hydro Units say the same thing. */
const IST = { timeZone: 'Asia/Kolkata' };
function sinceWhen(ts) {
  const d = new Date(ts * 1000);
  const day = x => x.toLocaleDateString('en-CA', IST);
  const time = d.toLocaleTimeString('en-IN', { ...IST, hour: 'numeric', minute: '2-digit' }).toLowerCase();
  if (day(d) === day(new Date())) return time;
  return `${d.toLocaleDateString('en-IN', { ...IST, day: 'numeric', month: 'short' })}, ${time}`;
}

export function controllerLink(report) {
  if (!report) return { state: 'none', word: 'No board', short: 'No controller', title: 'No light controller has ever reported for this unit.' };
  const s = Math.max(0, report.age_seconds || 0);
  const age = s < 3600 ? `${Math.max(1, Math.round(s / 60))} min`
    : s < 86400 ? `${Math.floor(s / 3600)} h` : `${Math.floor(s / 86400)} d`;
  const since = report.since ? sinceWhen(report.since) : null;
  const seen = sinceWhen(report.last_seen);
  return report.online
    ? { state: 'online', word: 'Online', short: since ? `Online since ${since}` : 'Online', age, title: `Light controller online${since ? ` since ${since}` : ''}, last report ${seen}` }
    : { state: 'offline', word: 'Offline', short: `Offline since ${since || seen}`, age, title: `Light controller offline since ${since || seen} (${age} ago)` };
}
